<h1
  *ngIf="transactionConfiguration?.title && customTitle === ''"
  [ngClass]="{ 'rs-has-subtit': transactionConfiguration?.subtitle }"
  data-cy="myBillOdbCategoryDetailsHeaderTitle"
>
  {{ transactionConfiguration.title }}
</h1>
<h1
  *ngIf="transactionConfiguration?.title && customTitle !== ''"
  class="rs-has-subtit"
  data-cy="myBillOdbCategoryDetailsHeaderTitle"
>
  {{ customTitle }} <span class="hide-for-small-only">-</span
  ><br class="show-for-small-only" />
  {{ transactionConfiguration.title }}
</h1>
<h2
  *ngIf="transactionConfiguration?.subtitle"
  class="rs-subtit"
  data-cy="myBillOdbCategoryDetailsHeaderSubtitle"
>
  {{ transactionConfiguration.subtitle }}
</h2>
